import './ClarifyModal.scss';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ButtonWithLoader } from '../../../../../../design/buttons/ButtonWithLoader';
import { S_Modal } from '../../../../../../design/modals/modal/S_Modal';
import { TextAreaWithAutocomplete } from '../../../../../components/TextAreaWithAutocomplete';
import { IClarification } from '../models/Clarifications.models';

interface IProps {
  showModal: boolean;
  clarification: IClarification;
  answer: string;
  onToggleChange: () => void;
  onAnswerChange: (value: string) => void;
  onSaveClarificationAnswer: () => Promise<void>;
}

export const ClarifyModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_Modal
      className='image-clarifications-modal'
      isOpen={props.showModal}
      toggle={props.onToggleChange}
      headerText={t('clarifications.answer_modal.header')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.onToggleChange}
          >
            {t('cancel')}
          </Button>
          <ButtonWithLoader
            loaderKey='answer-clarification-button'
            id='answer-clarification'
            onClick={props.onSaveClarificationAnswer}
            disabled={!props.answer}
          >
            {t('clarifications.answer_modal.save')}
          </ButtonWithLoader>
        </>
      }
    >
      <div>
        <span className='bold-text'>{t('clarifications.common.asked_by')}:</span> {props.clarification.askedBy}
      </div>
      <div>
        <span className='bold-text'>{t('clarifications.common.question')}:</span> {props.clarification.question}
      </div>
      <div>{t('clarifications.answer_modal.caption')}:</div>
      <TextAreaWithAutocomplete
        maxLength={210}
        value={props.answer}
        onChange={props.onAnswerChange}
        autocompleteOptions={[]}
        autofocus
        counter
      />
    </S_Modal>
  );
});
